<template>
    <div>
        <v-text-field
            v-model="modelValue"
            bg-color="gray-200"
            class="tw-h-11 tw-text-xs sm:tw-text-sm"
            clearable
            flat
            hide-details
            :loading="props.loading"
            :placeholder="$t('search.placeholder')"
            variant="solo"
            @click:clear="modelValue = ''">
            <template #prepend-inner>
                <SearchIcon class="tw-mx-1 tw-size-4 tw-text-gray-400" />
            </template>
        </v-text-field>
    </div>
</template>

<script setup lang="ts">
    import SearchIcon from '../icons/Search.vue';

    const modelValue = defineModel<string>();

    // defineProps with loading state
    const props = defineProps<{
        loading?: boolean;
    }>();
</script>

<style scoped></style>
